import { useEffect, useRef } from "react";

import { useAuthStore } from "../stores/useAuthStore";
import { usePanelsStore } from "../stores/usePanelsStore";
import { initPushNotifications } from "../functions/pushNotifications";

export default function usePushNotifications() {
  const { user } = useAuthStore();
  const { openPanel } = usePanelsStore();
  const initialized = useRef(false);

  useEffect(() => {
    if (!user?.uid || initialized.current) return;
    initialized.current = true;

    initPushNotifications({ user, openPanel }).catch((err) => {
      console.warn("Push init falhou:", err);
    });
  }, [user?.uid, user, openPanel]);
}
